import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { PageInfoService, PageLink } from '@metronic/layout';
import { IPayloadRegistrationDeliveryAddress, IPayloadRegistrationVerification } from '../../../interfaces/detail-registration.interface';
import { ICardProfileBody } from '@models/card.model';
import { SubMenu } from '../../../enum/submenu.enum';
import { UtilitiesService } from '@services/utilities.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DetailRegistrationDistributorService } from './detail-registration.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { STEPPER_GLOBAL_OPTIONS, StepperSelectionEvent } from '@angular/cdk/stepper';
import { DistributorStatusEnum } from '@config/enum/distributor.enum';
import { ITabList } from '@shared/interface/tablist.interface';
import { RolePrivilegeService } from '@services/role-privilege.service';
import { TabLabelEnumDetailDistributor, TabListLabelDetailDistributor } from '../../../enum/tablist-label.enum';
import { IHeaderDistributorDetail } from '../../../interfaces/detail-header.interface';
import { MatStepper } from '@angular/material/stepper';
import { ModalComponent } from '@shared/components/modal/modal.component';
import { ModalConfig } from '@shared/components/modal/modal.interface';
import { IGenericLabelValue } from '@shared/interface/generic';
import { STRING_CONSTANTS } from '@config/constants/string.constants';
import { InformasiNpwpComponent } from './informasi-npwp/informasi-npwp.component';
import { InformasiDistributorComponent } from './informasi-distributor/informasi-distributor.component';
import { DistributorService } from '../../../distributor.service';
import { IResponseApprovalDistributor } from '../../../interfaces/detail-verification.interface';
import { EnumDistributorRevisionSession } from '@config/enum/session.enum';

@Component({
  selector: 'app-detail-registration',
  templateUrl: './detail-registration.component.html',
  styleUrls: ['./detail-registration.component.scss'],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false },
    },
  ],
})
export class DetailRegistrationComponent implements OnInit, OnDestroy {
  @ViewChild('stepper') stepper!: MatStepper;
  @Input() detailHeaderSubject!: BehaviorSubject<IHeaderDistributorDetail>;

  id: any | null = null;
  status: any | null = null;
  tab: any | null = null;
  links: Array<PageLink>;
  isLoading = new BehaviorSubject(true);
  activeStepIndex = 0;

  // detailHeader = new BehaviorSubject<IHeaderDistributorDetail>({} as IHeaderDistributorDetail);
  detailCardHeaderLabelList: ICardProfileBody[];

  revisionNote: BehaviorSubject<IGenericLabelValue[]> = new BehaviorSubject<IGenericLabelValue[]>([]);
  dataResponse: BehaviorSubject<IResponseApprovalDistributor> = new BehaviorSubject<IResponseApprovalDistributor>({} as IResponseApprovalDistributor);
  revisionType: EnumDistributorRevisionSession;

  distributorDataForm: FormGroup = this.fb.group({
    scope: ['', Validators.required],
    distributor_detail: ['', Validators.required],
    owner: [''],
    manager: [''],
    business_branch: [''],
  });

  businessDataForm: FormGroup = this.fb.group({
    business_information: ['', Validators.required],
    supplier_information: ['', Validators.required],
  });

  creditCeilingForm: FormGroup = this.fb.group({
    credit_ceiling_granted: ['', Validators.required],
    sale_target: ['', Validators.required],
    credit_billing: ['', Validators.required],
  });

  shippingAddressForm: FormGroup = this.fb.group({
    delivery_address: [[], Validators.required],
  });

  documentForm: FormGroup = this.fb.group({
    document: ['', Validators.required],
    document_update_distributor: ['', Validators.required],
  });

  tabIndex = 0;
  tabList!: ITabList[];

  @ViewChild('modalConfirmRegistration') modalConfirmRegistration: ModalComponent;
  modalConfigConfirmRegistration: ModalConfig = {
    modalTitle: 'KONFIRMASI REGISTRASI DISTRIBUTOR',
    dismissButtonLabel: 'Lanjutkan',
    closeButtonLabel: 'Batal',
    onDismiss: () => this.onSubmitRegistration(),
  };

  @ViewChild('modalResponse') private modalResponse: ModalComponent;
  modalConfigResponse: ModalConfig = {
    closeButtonLabel: 'Lihat Detail',
    dismissButtonLabel: 'Oke',
    onClose: () => this.redirectToDetailPage(),
    onDismiss: () => this.redirectToListPage(),
    disableDismissButton: () => false,
    disableCloseButton: () => false,
  };

  // init declare object session
  revisionNoteData = {
    registrationFinance: <IPayloadRegistrationVerification>{
      revision_note: {
        npwp_information: null,
        npwp_document: null,
      },
    },
    registrationAdmin: {
      revision_note: {
        scope: null,
        distributor_detail: null,
        owner: null,
        manager: null,
        business_branch: null,
        business_information: null,
        supplier_information: null,
        credit_ceiling_granted: null,
        sale_target: null,
        credit_billing: null,
        document: null,
        npwp_information: null,
        npwp_document: null,
        document_update_distributor: null,
      },
      delivery_address: null,
    },
  };

  private unsubscribe: Subscription[] = [];

  get headerValue() {
    return this.detailHeaderSubject.value;
  }

  get sessionRevisionNote() {
    return this.registrationService.getSessionRevisionNote(this.revisionType) ?? ({} as IPayloadRegistrationDeliveryAddress);
  }

  constructor(
    private pageInfoService: PageInfoService,
    public utilities: UtilitiesService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private distributorService: DistributorService,
    public registrationService: DetailRegistrationDistributorService,
    private fb: FormBuilder,
    private rolePrivilegeService: RolePrivilegeService
  ) {
    const _routeParamSubs = this.activatedRoute.paramMap.subscribe((params) => {
      this.id = params.get('id');
      this.status = params.get('status');
      this.tab = params.get('tab');
    });
    this.registrationService.idValue = this.id;
    this.unsubscribe.push(_routeParamSubs);
  }

  ngOnInit() {
    this.getDataHeader();
  }

  initPageInfo() {
    this.links = [
      {
        title: 'Distributor',
        path: '',
        isActive: false,
      },
      {
        title: '',
        path: '',
        isActive: false,
        isSeparator: true,
      },
      {
        title: this.utilities.SubMenuBreadcrumbTitles(this.status, SubMenu) ?? 'Distributor',
        path: `distributor/${this.status}/${this.tab}`,
        isActive: false,
      },
      {
        title: '',
        path: '',
        isActive: false,
        isSeparator: true,
      },
      {
        title: this.utilities.toCapitalize(this.headerValue.business_name),
        path: '',
        isActive: true,
      },
    ];
    this.pageInfoService.updateBreadcrumbs(this.links);
    this.pageInfoService.updateTitle('Detail Distributor');
  }

  getDataHeader() {
    this.detailHeaderSubject.subscribe((resp) => {
      if (resp && !Object.keys(resp).length) return;

      const { status_enum } = resp;

      this.initPageInfo();
      this.initTabList();

      this.revisionType =
        status_enum === DistributorStatusEnum.PENDING_REGISTRATION ? EnumDistributorRevisionSession.REGISTRATION_ADMIN : EnumDistributorRevisionSession.REGISTRATION_FINANCE;
      this.initRevisionNoteSession();

      this.isLoading.next(false);
    });
  }

  onStepChange(event: StepperSelectionEvent): void {
    this.activeStepIndex = event.selectedIndex;
  }

  initRevisionNoteSession() {
    const _revisionNoteData =
      this.revisionType === EnumDistributorRevisionSession.REGISTRATION_ADMIN ? this.revisionNoteData.registrationAdmin : this.revisionNoteData.registrationFinance;

    // to reset session on init page
    // this.registrationService.setSessionRevisionNote(_revisionNoteData, this.revisionType);
    // uncomment or delete below
    if (this.hasSessionRevision()) return;
    else this.registrationService.setSessionRevisionNote(_revisionNoteData, this.revisionType);
  }

  hasSessionRevision() {
    return this.sessionRevisionNote && !!Object.keys(this.sessionRevisionNote).length;
  }

  initTabList() {
    this.tabList = this.distributorService.generateDistributorDetailTabList(this.headerValue.status_enum);
    this.tabList.map((tab, index) => {
      tab.privilege = this.rolePrivilegeService.checkPrivilege('DISTRIBUTOR', 'DETAIL_DISTRIBUTOR', tab.enum);
      tab.index = index;
      if (tab.enum === TabLabelEnumDetailDistributor.TAB_NPWP_INFORMATION) tab.component = InformasiNpwpComponent;
      if (tab.enum === TabLabelEnumDetailDistributor.TAB_DISTRIBUTOR_INFORMATION) tab.component = InformasiDistributorComponent;
    });
  }

  handleTabChange = (e: number) => (this.tabIndex = e);

  handleConfirm() {
    this.generateNoteRevision();
    this.modalConfirmRegistration.open().then();
  }

  generateNoteRevision() {
    const revisionNoteData = this.sessionRevisionNote;
    const data = this.distributorService.generateNoteRevision(revisionNoteData) ?? [];
    this.revisionNote.next(data);
  }

  onSubmitRegistration() {
    const revision = this.sessionRevisionNote;
    const delivery_address = revision.delivery_address.map((value: { id: any; note: any }) => ({
      id: value.id,
      note: value.note,
    }));
    const revision_note = revision.revision_note;
    if (revision_note || delivery_address) {
      const payload = {} as IPayloadRegistrationVerification;
      payload.revision_note = revision_note;
      revision_note.delivery_address = delivery_address;
      this.registrationService.submitRegistrationAdmin(payload).subscribe((val) => {
        if (val && val.success) {
          this.registrationService.clearSessionRevisionNote(this.revisionType);
          this.dataResponse.next(val.data);
          this.modalResponse.open().then();
        }
      });
    }
    return true;
  }

  async redirectToDetailPage() {
    const { distributor_id } = this.dataResponse.value;
    if (!!this.revisionNote.value && this.revisionNote.value.length > 0) {
      this.router.navigate([`/distributor/detail/reject/registration/` + distributor_id]).then(() => window.location.reload());
      return true;
    } else {
      this.router.navigate(['/distributor/detail/pending/registration/' + distributor_id]).then(() => window.location.reload());
      return true;
    }
  }

  async redirectToListPage() {
    return this.router.navigate(['/distributor/pending/registration']);
  }

  generateResponseSuccess() {
    if (this.revisionNote.value.length > 0) {
      return 'Distributor berhasil dikonfirmasi.\n' + 'Catatan perbaikan & Data Distributor dikembalikan ke Regional Head.';
    } else {
      return 'Distributor berhasil dikonfirmasi & diteruskan ke Finance.';
    }
  }

  showBtnGroup() {
    return this.registrationService.checkBtnVerification(this.tab);
  }

  ngOnDestroy() {}

  protected readonly TabListLabelDetailDistributor = TabListLabelDetailDistributor;
  protected readonly STRING_CONSTANTS = STRING_CONSTANTS;
  protected readonly DistributorStatusEnum = DistributorStatusEnum;
}
